module.exports = __webpack_public_path__ + "static/ETNOW-e467c6e2761fb5e1f932de9efe154e4d.png";